import { message, Tabs } from 'antd'
import axios from 'axios'
import React, { FunctionComponent, useEffect, useMemo, useState } from 'react'

import { CeeStatisticsTable } from '../components/CeeStatisticsTable/CeeStatisticsTable'
import { MarketplaceStatisticsTable } from '../components/MarketplaceStatisticsTable/MarketplaceStatisticsTable'
import { MonitStatisticsTable } from '../components/MonitStatisticsTable/MonitStatisticsTable'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { PostServiceStatisticsTable } from '../components/PostServiceStatisticsTable/PostServiceStatisticsTable'
import { StatisticCompany, SystemCompany } from '../utils/statisticHelpers'
import { STATISTIC_TAB_KEYS, TabItem, tabsProps } from '../utils/tabsHelpers'
import { useTabKeyState } from '../utils/useTabKeyState'

export const Statistics: FunctionComponent = () => {
  const [activeTabKey, setActiveTabKey] = useTabKeyState<STATISTIC_TAB_KEYS>(
    STATISTIC_TAB_KEYS.CEE
  )

  const [companies, setCompanies] = useState<StatisticCompany>()

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await axios.get<SystemCompany[]>('/api/firmy', {
          withCredentials: true,
        })

        const companies = Array.isArray(response.data)
          ? response.data.reduce((acc: StatisticCompany, company) => {
              acc[company.id] = company.nazev
              return acc
            }, {})
          : {}

        setCompanies(companies)
      } catch {
        message.error('Nepodařilo se načíst názvy firem.')
        setCompanies({})
      }
    }

    if (!companies) fetchCompanies()
  }, [companies])

  const tabItems = useMemo<TabItem<STATISTIC_TAB_KEYS>[]>(
    () => [
      {
        key: STATISTIC_TAB_KEYS.CEE,
        label: 'CEE',
        className: 'bg-white py-2',
        children: <CeeStatisticsTable companies={companies} />,
      },
      {
        key: STATISTIC_TAB_KEYS.PRICE_ESTIMATE,
        label: 'Cenové odhady',
        className: 'bg-white py-2',
        children: <MonitStatisticsTable companies={companies} />,
      },
      {
        key: STATISTIC_TAB_KEYS.CPOST,
        label: 'Pošta',
        className: 'bg-white py-2',
        children: <PostServiceStatisticsTable companies={companies} />,
      },
      {
        key: STATISTIC_TAB_KEYS.MARKETPLACE,
        label: 'Marketplace',
        className: 'bg-white py-2',
        children: <MarketplaceStatisticsTable companies={companies} />,
      },
    ],
    [companies]
  )

  return (
    <PageLayout title={'Statistiky využití - ' + activeTabKey}>
      <Tabs
        {...tabsProps}
        activeKey={activeTabKey}
        onChange={setActiveTabKey}
        items={tabItems}
      />
    </PageLayout>
  )
}

export default Statistics
